import EndLessonButton from 'app/components/call/BookingDetails/LessonBookingDetails/EndLessonButton';
import ReadyButton from 'app/components/call/BookingDetails/LessonBookingDetails/ReadyButton';
import { ILessonUIState, LessonButtonStage } from 'app/models/ui/call/lesson/constants';
import React, { FC } from 'react';

interface IProps {
  lessonUIState: ILessonUIState;
}

/**
 * Renders the correct button UI depending on the state of the call.
 */
const LessonButton: FC<IProps> = ({ lessonUIState }) => {
  if (lessonUIState.button === LessonButtonStage.ShowReadyPulsing) {
    return <ReadyButton pulse />;
  }

  if (lessonUIState.button === LessonButtonStage.ShowEnd || lessonUIState.button === LessonButtonStage.ShowEndUrgent) {
    return <EndLessonButton variant={lessonUIState.button} />;
  }

  return null;
};

export default LessonButton;
